import {
  getObject,
} from "@surya-digital/leo-ts-types";
import { ChatSurveyTimelineUpdate } from "./chatSurveyTimelineUpdate";
import { ProgressPercentage, ProgressPercentageDTO } from "./progressPercentage";
import { ChatSurveyNextAction } from "./chatSurveyNextAction";

export interface ChatSurveyMutationResultDTO {
  timelineUpdate: ChatSurveyTimelineUpdate.ChatSurveyTimelineUpdateDTO;
  progressPercentage: ProgressPercentageDTO;
  nextAction: ChatSurveyNextAction.ChatSurveyNextActionDTO;
}

export class ChatSurveyMutationResult {
  readonly isChatSurveyMutationResultChatSurveyMutationResult: boolean = true;

  readonly timelineUpdate: ChatSurveyTimelineUpdate.ChatSurveyTimelineUpdate;
  readonly progressPercentage: ProgressPercentage;
  readonly nextAction: ChatSurveyNextAction.ChatSurveyNextAction;


  constructor(
  timelineUpdate: ChatSurveyTimelineUpdate.ChatSurveyTimelineUpdate, 
  progressPercentage: ProgressPercentage, 
  nextAction: ChatSurveyNextAction.ChatSurveyNextAction
  ) {
    this.timelineUpdate = timelineUpdate;
    this.progressPercentage = progressPercentage;
    this.nextAction = nextAction;
  }

  static fromDTO(dto: ChatSurveyMutationResultDTO): ChatSurveyMutationResult {
    const timelineUpdate = ChatSurveyTimelineUpdate.fromDTO(getObject(dto, "timelineUpdate", InvalidChatSurveyMutationResultTimelineUpdateError));
    const progressPercentage = ProgressPercentage.fromDTO(getObject(dto, "progressPercentage", InvalidChatSurveyMutationResultProgressPercentageError));
    const nextAction = ChatSurveyNextAction.fromDTO(getObject(dto, "nextAction", InvalidChatSurveyMutationResultNextActionError));
    return new ChatSurveyMutationResult(
      timelineUpdate,
      progressPercentage,
      nextAction
    );
  }

  toDTO(): ChatSurveyMutationResultDTO {
    const dto: ChatSurveyMutationResultDTO = {
        timelineUpdate: this.timelineUpdate.toDTO(),
        progressPercentage: this.progressPercentage.toDTO(),
        nextAction: this.nextAction.toDTO()
    };
    return dto;
  }
  }

ChatSurveyMutationResult.prototype.toString = function toString(): string {
  return `ChatSurveyMutationResult(timelineUpdate='${this.timelineUpdate}',progressPercentage='${this.progressPercentage}',nextAction='${this.nextAction}')`;
};

export class InvalidChatSurveyMutationResultError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyMutationResultError";
  }
}
export class InvalidChatSurveyMutationResultTimelineUpdateError extends InvalidChatSurveyMutationResultError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyMutationResultTimelineUpdateError";
  }
}

export class InvalidChatSurveyMutationResultProgressPercentageError extends InvalidChatSurveyMutationResultError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyMutationResultProgressPercentageError";
  }
}

export class InvalidChatSurveyMutationResultNextActionError extends InvalidChatSurveyMutationResultError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyMutationResultNextActionError";
  }
}
